import React from 'react';
import { TipsMapType } from '../index';

export const NIKKEGPTTips: TipsMapType = {
  en: `GPT prepares a summary of the previous week's Opinions report every Monday. Click the "Week" option in the time filter to view the weekly GPT summaries.`,
  zh: '每周一将总结上一个自然周的舆情报告。请点击时间筛选器中的“周”选项，查看每周的总结。',
};

export const NIKKEPositiveRatioTips: TipsMapType = {
  en: `Positive%: By calculating the proportion of positive mentions for a NIKKE character relative to the total mentions in the game. This helps in comparing the positive mention ratios of different characters across the entire game.`,
  zh: '正面声量占比：通过计算角色的正面声量占游戏总声量的比例，计算出角色的正面声量占比。帮助对比全局不同角色间的正面声量占比情况。',
};

export const NIKKENegativeRatioTips: TipsMapType = {
  en: `Negative%: By calculating the proportion of negative mentions for a NIKKE character relative to the total mentions in the game. This helps in comparing the negative mention ratios of different characters across the entire game.`,
  zh: '负面声量占比：通过计算角色的负面声量占游戏总声量的比例，计算出角色的负面声量占比。帮助对比全局不同角色间的负面声量占比情况。',
};

export const NIKKENeutralRatioTips: TipsMapType = {
  en: `Neutral%: By calculating the proportion of neutral mentions for a NIKKE character relative to the total mentions in the game. This helps in comparing the neutral mention ratios of different characters across the entire game.`,
  zh: '中性声量占比：通过计算角色的中性声量占游戏总声量的比例，计算出角色的中性声量占比。帮助对比全局不同角色间的中性声量占比情况。',
};
